import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  authenticator: generateApiPath({ prefix: AuthLevel.PUBLIC, name: 'authenticator' }),
  user: generateApiPath({ prefix: AuthLevel.PUBLIC, name: 'user' }),
}

export { paths }
